module.exports = __webpack_public_path__ + "img/techalliance-poster-image.a0565129.jpg";